/** Обрізає час до хвилини (UTC) — сек. та мс = 0 */
export function floorToMinuteUTC(d: Date): Date {
    return new Date(Date.UTC(
        d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(),
        d.getUTCHours(), d.getUTCMinutes(), 0, 0
    ));
};

/** Повертає [from, to] за останні n хвилин у UTC, обидві межі обрізані до хвилини */
export const lastMinutesRangeUTC = (n: number): { from: Date; to: Date } => {
    const to = floorToMinuteUTC(new Date());
    const from = new Date(to.getTime() - n * 60_000);
    return { from, to };
};

export const lastMinutesToEndOfDayUTC = (n: number): { from: Date; to: Date } => {
    const now = new Date();

    // from = зараз - 5 хвилин, округлено вниз до хвилини
    const from = floorToMinuteUTC(new Date(now.getTime() - n * 60_000));

    // to = кінець поточного дня UTC (23:59:59)
    const endOfDayUTC = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        23, 59, 59, 0
    ));

    return { from, to: endOfDayUTC };
};

/** ISO у UTC без мілісекунд, обрізаний до хвилини, з "Z" */
export const toUTCMinuteISOString = (d: Date): string => {
    const f = floorToMinuteUTC(d);
    // приклад: 2025-10-15T12:34:00Z
    return f.toISOString().replace(/\.\d{3}Z$/, "Z");
};

/** Початок доби в UTC */
export const startOfDayUTC = (d: Date): Date => {
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0, 0));
};

/** Кінець доби в UTC (23:59:59) */
export const endOfDayUTC = (d: Date): Date => {
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 23, 59, 59, 0));
};

export const toBackendUTCString = (d: Date): string => {
    const iso = toUTCMinuteISOString(d);
    return iso.replace("Z", "");
};

export function displayLocalDateToBackendUTCString(d: Date): string {
    const utc = new Date(Date.UTC(
        d.getFullYear(), d.getMonth(), d.getDate(),
        d.getHours(), d.getMinutes(), 0, 0
    ));
    // "YYYY-MM-DDTHH:mm:ss" (без Z)
    return utc.toISOString().replace(/\.\d{3}Z$/, "");
};

/** Парсинг ISO-рядка у Date (з підтримкою "Z") */
export const parseUTC = (dateStr?: string | null): Date | null => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
};

export const parseBackendUTC = (s?: string | null): Date | null => {
    if (!s) return null;
    const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/.exec(s);
    if (!m) return null;
    const [_, Y, M, D, h, m_, s_] = m.map(Number);
    return new Date(Date.UTC(Y, M - 1, D, h, m_, s_, 0));
};

export const parseUTCFromUrl = (s?: string | null): Date | null => {
    if (!s) return null;
    const norm = /Z$/i.test(s) ? s : `${s}Z`;
    const d = new Date(norm);
    return isNaN(d.getTime()) ? null : d;
};


export const parseFromUrl = (s?: string | null): Date | null => {
    if (!s) return null;
    return new Date(s); // без додавання 'Z'!
};

export const toLocalMinuteISOString = (d?: Date | null): string => {
    if (!d) return "";
    const pad = (n: number) => String(n).padStart(2, "0");
    const dd = new Date(d.getTime()); // копія
    dd.setSeconds(0, 0);
    const Y = dd.getFullYear();
    const M = pad(dd.getMonth() + 1);
    const D = pad(dd.getDate());
    const h = pad(dd.getHours());
    const m = pad(dd.getMinutes());
    return `${Y}-${M}-${D}T${h}:${m}:00`;
};

export const toDisplayTZ = (d: Date | null) =>
    d ? new Date(d.getTime() + d.getTimezoneOffset() * 60000) : null;

export const fromDisplayTZ = (d: Date | null) =>
    d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000) : null;